module.exports = __webpack_public_path__ + "media/npc_dota_hero_void_spirit.db39c908.webm";